// src/App.js
import React from 'react';
import StockMarketTable from './components/StockMarketTable';

function App() {
  return (
    <div className="App">
      {/* <h1>World Stock Market Hours</h1> */}
      <StockMarketTable />
    </div>
  );
}

export default App;
